import React, { useContext, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import clsx from 'classnames';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Jumbotron } from 'components/jumbotron/jumbotron';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { loginRedirect } from 'utils';
import { AuthCtx } from 'components/auth/auth-ctx';

const useStyles = makeStyles(() =>
  createStyles({
    section: {
      marginTop: 50,
    },
    content: {
      padding: '0 0 50px 0',
    },
    loginButtonWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
  })
);

export function Registration() {
  const { userInfo, userLoaded } = useContext(AuthCtx);
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const history = useHistory();

  useEffect(() => {
    if (userLoaded && userInfo) {
      history.push('/portfolio/badatelske-listy');
    }
  }, [history, userInfo, userLoaded]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Jumbotron
          title={formatMessage({
            id: 'registration.jumbotron',
            defaultMessage: 'Registrace',
          })}
        />
        <Grid container className={classes.content}>
          <Grid item xs={1} md={3} />
          <Grid item xs={10} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={8}>
                <Typography
                  variant="body1"
                  align="left"
                  className={classes.section}
                >
                  Pokud již <b>MÁTE</b> účet v Centrální autentizační službě UK
                  (CAS UK), přihlaste se pomocí níže uvedeného odkazu.
                </Typography>
              </Grid>
              <Grid item xs={12} md={2} />
            </Grid>
            <div className={clsx(classes.loginButtonWrapper, classes.section)}>
              <Button
                component="span"
                variant="contained"
                color="primary"
                onClick={() => loginRedirect('/badatelna/registracni-formular')}
              >
                <Typography component="span" variant="body2">
                  Přihlásit se do CAS UK
                </Typography>
              </Button>
            </div>
          </Grid>
        </Grid>
        <Grid container className={classes.content}>
          <Grid item xs={1} md={3} />
          <Grid item xs={10} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={8}>
                <Typography
                  variant="body1"
                  align="left"
                  className={classes.section}
                >
                  Pokud ještě <b>NEMÁTE</b> vytvořený účet v Centrální
                  autentizační službě (CAS), pokračujte níže. Zadaná data budou
                  použita pro vytvoření účtu. Vytvoření účtu musí schválit
                  správce badatelny Archivu UK.
                </Typography>
              </Grid>
              <Grid item xs={12} md={2} />
            </Grid>
            <div className={clsx(classes.loginButtonWrapper, classes.section)}>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/registracni-formular"
              >
                <Typography component="span" variant="body2">
                  Požádat o účet v CAS UK
                </Typography>
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
